module.exports = __webpack_public_path__ + "static/media/emojis_04.08dfea20.svg";